export default {
  authTokenExpired: 'Authentication token was expired',
  userDoesNotHaveUiRole: 'User does not have UI role',
};
